import http from '@/api/http'

export default {
  /**
   * Android アプリがリジェクトされたかチェック
   */
  checkRejectAndroid(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/check_reject_android/', {
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 使用中のアプリが最新バージョンかチェック
   */
  checkMustUpdate(params): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/check_app_version/', {
          page: 'check',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  }
}
